






















































import { Component, Mixins, Watch, Emit } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../base/components/system/mixins";
import {
  TabSelector,
} from "../../../../base/components/system/selectors";
import { EditableFormatSummary } from "../../../domain/editableFormat";
import { default as FilterableFormatsSelector } from "./FilterableFormatsSelector.vue";
import { default as UserEditedFormatsSelector } from "./UserEditedFormatsSelector.vue";
import { default as DeletedFormatSelector } from "./DeletedFormatSelector.vue";

@Component({
  components: {
    TabSelector,
    FilterableFormatsSelector,
    UserEditedFormatsSelector,
    DeletedFormatSelector,
  }
})
export default class FormatTwoPaneSelector extends Mixins(ModelEditableMixin) {
  listTabs: { name: string, description: string }[] = [
    {
      name: "すべて",
      description: "全てのフォーマットから絞り込んで表示します。",
    },
    {
      name: "最近編集したフォーマット",
      description: "最近自分が編集したフォーマットを表示します。",
    },
    {
      name: "削除・非表示フォーマット",
      description: "削除されたフォーマット、有効で階層に表示されていないフォーマットを表示します。"
    },
  ];
  selectedListTab: { name: string, description: string } = this.listTabs[0];
  selectionOfFilterableFormat: EditableFormatSummary = null;
  selectionOfUserEditedFormat: EditableFormatSummary = null;
  selectionOfDeletedFormat: EditableFormatSummary = null;

  $refs!: {
    filterableFormatsSelector: FilterableFormatsSelector,
    userEditedFormatsSelector: UserEditedFormatsSelector,
    deletedFormatsSelector: DeletedFormatSelector,
  };

  get visibleListTabs(): { name: string, description: string }[] {
    return this.listTabs;
  }

  get formatNameWording(): string {
    return this.$wording.format.name;
  }

  replaceWording(text: string): string {
    return text.replace(/フォーマット/g, this.formatNameWording);
  }

  mounted() {
    window.addEventListener("message", this.onChildWindowNotify, false);
  }

  private onChildWindowNotify(event: any): void {
    try {
      const message = JSON.parse(event.data) as { key: string };
      if (message.key === "finishEditing") {
        this.updateListTab();
      }
    } catch {}
  }

  @Watch("selectedListTab")
  onSelectedListTabUpdated(newValue: { name: string, description: string }, oldValue: { name: string, description: string }): void {
    switch (newValue.name) {
      case this.listTabs[0].name:
        this.editingSource = this.selectionOfFilterableFormat;
        break;
      case this.listTabs[1].name:
        this.editingSource = this.selectionOfUserEditedFormat;
        break;
      case this.listTabs[2].name:
        this.editingSource = this.selectionOfDeletedFormat;
        break;
    }
    this.selectedListTabChanged(this.replaceWording(newValue.name));
  }

  @Watch("selectionOfFilterableFormat")
  onSelectionOfFilterableFormatUpdated(newValue: EditableFormatSummary, oldValue: EditableFormatSummary): void {
    this.editingSource = this.selectionOfFilterableFormat;
  }

  @Watch("selectionOfUserEditedFormat")
  onSelectionOfUserEditedFormatUpdated(newValue: EditableFormatSummary, oldValue: EditableFormatSummary): void {
    this.editingSource = this.selectionOfUserEditedFormat;
  }

  @Watch("selectionOfDeletedFormat")
  onSelectionOfDeletedFormatUpdated(newValue: EditableFormatSummary, oldValue: EditableFormatSummary): void {
    this.editingSource = this.selectionOfDeletedFormat;
  }

  shouldShowListContent(index: number): boolean {
    return this.selectedListTab
      && (this.selectedListTab.name === this.listTabs[index].name);
  }

  updateListTab(): void {
    switch (this.selectedListTab.name) {
      case this.listTabs[0].name:
        this.$refs.filterableFormatsSelector.loadFormatTree();
        break;
      case this.listTabs[1].name:
        this.$refs.userEditedFormatsSelector.loadUserEditedFormats();
        break;
      case this.listTabs[2].name:
        this.$refs.deletedFormatsSelector.loadDeletedFormats();
        break;
    }
  }

  showEditHistory(): void {
    this.$openWindow("/ShowEditHistory");
  }

  @Emit("editingFormat")
  editingFormat(value: boolean): void {}

  @Emit("formatDoubleClicked")
  formatDoubleClicked(): void {}

  @Emit("folderSelectionChanged")
  folderSelectionChanged(formats: EditableFormatSummary[]): void {}

  @Emit("selectedListTabChanged")
  selectedListTabChanged(name: string): void {}
}
